// extracted by mini-css-extract-plugin
export default {"root":"IconButtonDots_root__3wwJm"};